import {createApi, fetchBaseQuery, retry} from '@reduxjs/toolkit/query/react';
import {oktaAuth} from '../components/Okta/AuthService';

const staggeredBaseQuery = retry(
  fetchBaseQuery({
    baseUrl: process.env.REACT_APP_JAVA_API_URL,
    prepareHeaders: async (headers) => {
      const tokenObj = await oktaAuth.tokenManager.get('accessToken');
      const token = (tokenObj as {accessToken?: string} | undefined)
        ?.accessToken;
      if (token) headers.set('authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  {maxRetries: 3},
);

export interface HomeCatalogResponse {
  spend: number;
  savings: number;
}

export interface HomeCatalogQueryArgs {
  category: string;
  isToggleEnabled: boolean;
}

export const homeCatalogApi = createApi({
  reducerPath: 'homeCatalogApi',
  baseQuery: staggeredBaseQuery,
  endpoints: (builder) => ({
    getHomeCatalog: builder.query<HomeCatalogResponse, HomeCatalogQueryArgs>({
      query: ({category, isToggleEnabled}) => ({
        url: `/${category}?is_toggle_enabled=${isToggleEnabled}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 10 * 60,
    }),
  }),
});

export const {useGetHomeCatalogQuery} = homeCatalogApi;
